// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Video-video-0de1{display:none;width:0;height:0;opacity:0}.Video-good-0de1{display:block;width:100%;height:100%;object-fit:contain;opacity:1}`, "",{"version":3,"sources":["webpack://./widget/ui/preview/Carousel/Video.module.scss"],"names":[],"mappings":"AAAA,kBACE,YAAA,CACA,OAAA,CACA,QAAA,CACA,SAAA,CAGF,iBACE,aAAA,CACA,UAAA,CACA,WAAA,CACA,kBAAA,CACA,SAAA","sourcesContent":[".video {\n  display: none;\n  width: 0;\n  height: 0;\n  opacity: 0;\n}\n\n.good {\n  display: block;\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  opacity: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"video": `Video-video-0de1`,
	"good": `Video-good-0de1`
};
module.exports = ___CSS_LOADER_EXPORT___;
